export default "__VITE_ASSET__BC_BTTp2__"